import React, { useEffect, useState } from 'react'
import './PayloadReview.scss'
import Observations from '../common/ObservationPayload'
import Modal from '../common/Modal/Modal'
import Button, {ButtonsHolder} from '../../../partials/Button'
import FeedbackBlock from '../../../partials/FeedbackBlock';
// import SatelliteSVG from './SateliteSVG'
// import Icon from '../../../partials/Icons'

const PayloadReview = (props) => {

    const { data, kpiFeedback, onBack, onComplete, config } = props

    /** States */
    const [simulationData, setSimulationData] = useState();
    const [missionResult, setMissionResult] = useState();
    const [showFeedback, setShowFeedback] = useState(false);

    useEffect(()=> {

        setSimulationData(data)

    },[])

    const handleComplete = () => {
        onComplete();
    }

    const handleRunSimulation = () => {

        if(!simulationData){
            setMissionResult({
                state: 'incomplete',
                text:'This could work!'
            })
        }
        else{

            setMissionResult({
                state: 'success',
                text:'This could work!'
            })

        }
        setShowFeedback(true)
    }

    const handleClose = () => {
        setShowFeedback(false)

    }
    const checkApprox = (num1, num2, epsilon = 25) => {
        return Math.abs(num1 - num2) < epsilon;
      }
    return (
        <div className="payload-review">
            { showFeedback &&
                <Modal
                    size="small"
                    show={true}
                    onClose={ handleClose }
                    header={missionResult.text}>

                    <Button text="Next" className="small centered primary" onClick={handleComplete}  />

                </Modal>
            }
            <div className='payload-review-content'  >

                <div className='columns'>
                    <FeedbackBlock status="default" caption={ config?.observationPayload || "Observation Payload" }>
                        <Observations data={data}/>
                        <Button text={ config?.changePayloadButton || "change payload" } onClick={() => onBack('Decisions') }  />
                    </FeedbackBlock>

                </div>

                <div className='columns'>
                    <FeedbackBlock status="default" caption={ config?.kpiFeedback || "KPI Feedback" } variant="wide">

                        <div className="column">
                            {kpiFeedback.markers && kpiFeedback.markers.map((marker, index)=>{
                                const kpi = kpiFeedback.kpis.find((kpi) => kpi.title === marker.title)
                                const correct = checkApprox(kpi.value, marker.value)
                                const feedback = correct ? marker.outcomes.success : kpi.value > marker.value ? marker.outcomes.higher : marker.outcomes.lower;

                                return (<div key={index} className='kpiFeedback'>
                                            {/*<Icon name={correct ? 'check' : 'incorrect'} />*/}
                                            <div className='kpiFeedback_Block'>
                                                <h3 className="kpiFeedback_Title">{marker.title} </h3>
                                                <p className="kpiFeedback_Body">{feedback}</p>
                                            </div>
                                        </div>)

                            })}
                        </div>
                    </FeedbackBlock>
                    <ButtonsHolder orientation="right" >
                        <Button text={ config?.reviewNextButton || "Next" } onClick={handleComplete} />
                    </ButtonsHolder>
                </div>
            </div>
        </div>
    )

}

export default PayloadReview;
